import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      display: 'flex',
      flexDirection: 'column',
      pr: 0,
      minHeight: ['400px', '500px'],
    };

    this.header = {
      // minHeight: ['35px', '45px', '60px'],
    };

    this.slider = {
      // minHeight: 441,
    };
  })()
);
